import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-created-date.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-created-date.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from "@angular/core";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationSearchConstants } from "../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaShortDatePipe } from "../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
let SearchCreatedDateComponent = class SearchCreatedDateComponent {
    calendar;
    formatter;
    applicationSearchService;
    aflaModuleStrategyService;
    saShortDatePipe;
    appController;
    store;
    _destroy$ = new Subject();
    noOfMonthsToDisplay;
    createdDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.createdDateFormControl;
    fromCreatedDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.fromCreatedDateFormControl;
    toCreatedDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.toCreatedDateFormControl;
    toDateLabel = ApplicationSearchConstants.FORM_CONTROLS.toDateLabel;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    datePlaceholder = ApplicationSearchConstants.FORM_CONTROLS.datePlaceholder;
    fromDateLabel;
    fromCreatedDate;
    toCreatedDate;
    createdDateForm;
    applicationSearchCallback;
    isSelectedToDate = false;
    isDisabledToCreatedDate = true;
    hoveredDate = null;
    tabChanged;
    constructor(calendar, formatter, applicationSearchService, aflaModuleStrategyService, saShortDatePipe, appController, store) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.saShortDatePipe = saShortDatePipe;
        this.appController = appController;
        this.store = store;
        this.fromCreatedDate = calendar.getToday();
        this.toCreatedDate = calendar.getToday();
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.createdDateForm = val;
            }
        });
        this.tabChanged = false;
        const fromDate = this.fromCreatedDate ? new Date(this.fromCreatedDate.year, this.fromCreatedDate.month - 1, this.fromCreatedDate.day) : null;
        if (fromDate)
            fromDate.setDate(fromDate.getDate() - 1);
        const toDate = this.toCreatedDate && this.noOfMonthsToDisplay > 1 ? new Date(this.toCreatedDate.year, this.toCreatedDate.month - 1, this.toCreatedDate.day)
            : (fromDate ? new Date(this.fromCreatedDate.year, this.fromCreatedDate.month - 1, this.fromCreatedDate.day) : null);
        if (!this.tabChanged) {
            this.applicationSearchCallback(this.applicationSearchService.searchByCreatedDate(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, this.saShortDatePipe.transform(fromDate), this.saShortDatePipe.transform(toDate)));
        }
    }
    // to be consistent, user must click 'Search' before we trigger the search for applications
    onDateSelection(date) {
        // let doSearch = false;
        if (!this.fromCreatedDate && !this.toCreatedDate) {
            this.fromCreatedDate = date;
            // doSearch = this.noOfMonthsToDisplay === 1;
        }
        else if (this.fromCreatedDate && !this.toCreatedDate && date && date.after(this.fromCreatedDate)) {
            this.toCreatedDate = date;
            // doSearch = this.noOfMonthsToDisplay > 1;
        }
        else {
            this.fromCreatedDate = date;
            this.toCreatedDate = null;
            // doSearch = this.noOfMonthsToDisplay === 1;
        }
        // if (doSearch)
        //   this.searchApplication(null);
    }
    setAutoClose() {
        return this.noOfMonthsToDisplay > 1 ? "'outside'" : true;
    }
    isHovered(date) {
        return this.noOfMonthsToDisplay > 1
            ? this.fromCreatedDate
                && !this.toCreatedDate
                && this.hoveredDate
                && date.after(this.fromCreatedDate)
                && date.before(this.hoveredDate)
            : false;
    }
    isInside(date) {
        return this.toCreatedDate && date.after(this.fromCreatedDate) && date.before(this.toCreatedDate);
    }
    isRange(date) {
        return this.noOfMonthsToDisplay > 1
            ? date.equals(this.fromCreatedDate)
                || (this.toCreatedDate && date.equals(this.toCreatedDate)) || this.isInside(date)
                || this.isHovered(date)
            : false;
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        if (!parsed && input !== "") {
            this.appController.showMessage(`${SharedConstants.DATE_INPUT_CONTROL_VALIDATION}`, AlertType.Warning);
            return currentValue;
        }
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    clearDate(dateCtrl) {
        if (dateCtrl === "fromDate")
            this.fromCreatedDate = null;
        else
            this.toCreatedDate = null;
    }
    setUpForm() {
        this.createdDateForm = new FormGroup({
            fromCreatedDateFormControl: new FormControl(null)
        });
        if (this.noOfMonthsToDisplay > 1) {
            this.createdDateForm.addControl("toCreatedDateFormControl", new FormControl(null));
        }
        this.fromDateLabel = this.noOfMonthsToDisplay > 1 ? ApplicationSearchConstants.FORM_CONTROLS.fromDateLabel : ApplicationSearchConstants.FORM_CONTROLS.dateLabel;
    }
    static ctorParameters = () => [
        { type: NgbCalendar },
        { type: NgbDateParserFormatter },
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: SaShortDatePipe },
        { type: AppControllerService },
        { type: Store }
    ];
    static propDecorators = {
        noOfMonthsToDisplay: [{ type: Input }]
    };
};
SearchCreatedDateComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-created-date",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchCreatedDateComponent);
export { SearchCreatedDateComponent };
